import { withAuth } from 'pages/ProtectedPage'
import { AreasList } from 'components/areas/AreasList'

export const AreasPage = () => {
  return (
    <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-4 tw-gap-2">
      <AreasList />
    </div>
  )
}

export const AreasPageProtected = withAuth(AreasPage)
